var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleUpArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 17.63 16.53",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.27 16.22c-.46.42-1.19.4-1.61-.06l-6.01-6.47c-.44-.48-1.21-.48-1.67 0l-6.01 6.47c-.42.46-1.15.48-1.61.06-.46-.42-.48-1.15-.06-1.61l7.68-8.25c.44-.48 1.21-.48 1.67 0l7.68 8.26c.42.46.4 1.19-.06 1.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.27 10.22c-.46.42-1.19.4-1.61-.06l-6.01-6.47c-.44-.48-1.21-.48-1.67 0l-6.01 6.48c-.42.46-1.15.48-1.61.06-.46-.42-.48-1.15-.06-1.61l7.68-8.26c.44-.48 1.21-.48 1.67 0l7.68 8.26c.42.46.4 1.19-.06 1.61z"
}))));
export default SvgDoubleUpArrow;